import type { FaireProductEntity } from "../../entity_types/product";

export const p_hpb7sjvh6x: FaireProductEntity = {
  token: "p_hpb7sjvh6x",
  type: "product",
  name: "Tropicana - 100% Juice, Apple, 10oz Bottle, 24/Carton",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/1be318452f94d30921880525814da882fd79ab9d2bafb4ba1e478fcbe084f713.jpeg",
  galleryImageUrls: [],
  priceDollars: 68.2,
  description:
    "Savor the refreshing taste of pure apple juice with every sip from this 10oz bottle. Crafted from the finest apples, this 100% juice is a delightful and nutritious way to quench your thirst. Perfect for lunches, picnics, or a quick on-the-go refreshment, this carton of 24 ensures you'll always have a delicious drink on hand.\n",
  tags: [],
  msrpDollars: 136.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:24.486Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
